import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Waypoint } from "react-waypoint";

//Description:
//HTML5 video with .mp4 video, the size is defined by the width and height properties

/*
//Usage:
<Video
    src="https://www.heyday.dk/media/1357/omos_graded_ny.mp4"
    caption="Lorem ipsum dolor sit amet, consectetur adipiscing elit."
    width={16}
    height={9} />
*/

interface VideoProps
{
    src: string;
    caption?: string;
    width: number;
    height: number;
    autoPlay?: boolean;
    muted?: boolean;
}

interface SizeProps
{
    ratio: string;
}

const FadeIn = keyframes`
     0% { opacity: 0; }
     100% { opacity: 1; }
`;

const FigureWrap = styled.figure`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    animation: ${FadeIn} .5s forwards;
`;

const FigureCaption = styled.figcaption`
    display: block;
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-size: 0.7333rem;
    opacity: .5;
    font-weight: 500;
`;

const VideoWrap = styled.div<SizeProps>`
    box-sizing: border-box;
    background-color: #000;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 0;
    padding-top: ${props => props.ratio}%;
    box-shadow: var(--shadow-md);
`;

const VideoPlayer = styled.video`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
`;

const Video: React.FC<VideoProps> = (props) =>
{
    const { height, width, src, caption, autoPlay, muted } = props;
    //In View state
    const [inView, setInView] = useState(false);

    //Aspect Ratio padding
    const ratio = (height / width) * 100;

    return (
        <Waypoint onEnter={() => setInView(true)} bottomOffset={-200}>
            <FigureWrap>
                <VideoWrap ratio={ratio.toFixed(2)}>
                    {inView ?
                        <VideoPlayer controls autoPlay={autoPlay} muted={autoPlay || muted}>
                            <source src={src} type="video/mp4" />
                            Your browser does not support the video tag.
                        </VideoPlayer>
                        : null}
                </VideoWrap>
                {caption ? <FigureCaption>{caption}</FigureCaption> : null}
            </FigureWrap>
        </Waypoint>
    );
};

export default Video;